<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas :notificacaoSocket="alertaSocket" :texto="alerta.texto" :tipo="alerta.tipo"></Alertas>

    <DataTable
      v-show="mostrarSkeleton == false"
      :tableTitle="'Configurações de Pedidos'"
      :newRowmodalButtonText="'Nova Configuração'"
      :tableHeader="headers"
      :tableRows="listaConfiguracoes"
      :totalItens="total"
      v-on:datatable-update-page="updatePage"
      v-on:datatable-update-search="updateSearch"
      :isEdit="true"
      :isDel="true"
      v-on:datatable-newrow="modalDeInserir"
      v-on:datatable-updaterow="modalDeAtualizar"
      v-on:datatable-deleterow="modalDeExcluir"
    ></DataTable>

    <SkeletonTable v-show="mostrarSkeleton == true" :showSkeletonTable="mostrarSkeleton"></SkeletonTable>

    <Loading :open="loading" />

    <ModalCustomSize
      :modalSize="customModal.size"
      :isTheModalOpen="customModal.isOpen"
      :modalButtonText="customModal.buttonText"
      :modalFormTitle="customModal.formTitle"
      :modalType="customModal.modalType"
      :isLoadingRequestDisable="customModal.isLoadingRequestDisable"
      :isModalButtonVisible="customModal.isButtonsVisible"
      :isModalButtonDisabled="customModal.isButtonsDisabled"
      v-on:formmodal-close="customModal.isOpen = false"
      v-on:formmodal-action="acoesModal"
    >
      <v-row>
        <v-col cols="12">
          <AlertasModal :tipo="alertaModal.tipo" :texto="alertaModal.texto"></AlertasModal>
        </v-col>
      </v-row>

      <v-form v-model="tudoValido">
        <v-row>
          <v-col cols="12">
            <v-textarea v-model="customModal.dadosModal.descricaoMensagem" name="descricaoMensagem" label="Descrição Mensagem" autocomplete="off" rows="1" counter="255" auto-grow :rules="[rules.required, rules.limitCharacters]"></v-textarea>
          </v-col>

          <v-col cols="12">
            <v-autocomplete label="Lista de Unidades" v-model="unidadeSelecionada" :items="listaDeUnidades"></v-autocomplete>
          </v-col>

          <v-col cols="12">
            <v-data-table :headers="headersUnidades" :search="searchUnidade" :items="customModal.dadosModal.unidadesConfiguracao">
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Unidades Configuradas</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn color="grey darken-4" class="grey--text text--lighten-5" @click="adicionarTodasUnidades">Todas Unidades</v-btn>
                </v-toolbar>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small @click="removerUnidadeConf(item)" v-bind="attrs" v-on="on">mdi-delete</v-icon>
                  </template>
                  <span>Remover</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-form>
    </ModalCustomSize>

    <DeleteItemModal :textModalDelete="modalDelete.texto" :showModalDelete="modalDelete.abrir" :buttomTextModalDelete="'Remover'" v-on:close-modal="modalDelete.abrir = false" v-on:on-response-modal-delete="excluir"></DeleteItemModal>
  </v-col>
</template>

<script>
import axios from "../plugins/axios";
import DataTable from "../components/DataTable2";
import store from "@/store/index";
import Loading from "../components/Loading.vue";
import ModalCustomSize from "../components/ModalCustomSize";
import DeleteItemModal from "../components/DeleteItemModal";
import SkeletonTable from "../components/SkeletonTable";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";

export default {
  components: {
    DataTable,
    Loading,
    ModalCustomSize,
    DeleteItemModal,
    SkeletonTable,
    Alertas,
    AlertasModal,
  },

  data: () => ({
    //#region Paginação
    page: 1,
    search: null,
    total: null,
    //#endregion

    //#region Alertas
    alerta: {
      texto: "",
      tipo: "",
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaModal: {
      texto: "",
      tipo: "",
    },

    alertaSnackbar: {
      mostrar: false,
      texto: null,
      cor: "red",
    },
    //#endregion

    rules: {
      required: (value) => !!value || "Requer o campo!",
      limitCharacters: (v) => (v && v.length <= 255) || "Limite de 255 caracteres.",
    },

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    //#region HEADERS
    headers: [
      {
        text: "Mensagem",
        value: "descricaoMensagem",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    headersUnidades: [
      {
        text: "Nº",
        value: "numeroEndereco",
      },
      {
        text: "Unidade",
        value: "nomeEndereco",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],
    //#endregion

    customModal: {
      size: "1080",
      isOpen: false,
      isEdit: false,
      showCloseMessage: true,
      formTitle: "",
      modalType: "",
      buttonText: "Concluir",
      isButtonsVisible: false,
      isButtonsDisabled: false,
      isLoadingRequestDisable: false,
      dadosModal: {
        descricaoMensagem: null,
        unidadesConfiguracao: [],
        unidadesConfiguracaoExcluidos: [],
      },
    },

    modalDelete: {
      abrir: false,
      texto: "Você realmente deseja remover essa configuração?",
      dadosDelete: {
        unidadesConfiguracao: [],
      },
    },

    loading: false,
    tudoValido: false,
    mostrarSkeleton: true,

    searchUnidade: null,
    unidadeSelecionada: null,

    listaConfiguracoes: [],
    listaDeUnidades: [],
  }),

  created() {
    this.mostrarSkeleton = true;
    this.inicializar();
  },

  watch: {
    tudoValido() {
      this.customModal.isButtonsDisabled = !this.tudoValido;
    },

    unidadeSelecionada() {
      if (this.unidadeSelecionada) {
        const verificarItem = this.customModal.dadosModal.unidadesConfiguracao.filter((unidade) => unidade.numeroEndereco == this.unidadeSelecionada);

        if (verificarItem.length <= 0) {
          const unidadeEncontrada = this.listaDeUnidades.filter((unidade) => unidade.numeroEndereco == this.unidadeSelecionada);

          this.customModal.dadosModal.unidadesConfiguracao.unshift(unidadeEncontrada[0]);
          this.unidadeSelecionada = "";
        } else {
          this.alertaModal.texto = "Essa unidade já se encontra na lista!";
          this.alertaModal.tipo = "erro";
          this.alertaSnackbar.texto = "Essa unidade já se encontra na lista!";
          this.alertaSnackbar.mostrar = true;
        }
      }
    },
  },

  methods: {
    //#region LISTAGENS
    async inicializar() {
      try {
        const response = await axios.put("listarconfiguracaopedido", { page: this.page, search: this.search }, this.config);

        if (!response.data || response.data.length > 0) {
          this.listaConfiguracoes = response.data;
          this.total = response.data[0].total;
        } else {
          this.listaConfiguracoes = [];
          this.total = 0;
        }
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        this.mostrarSkeleton = false;
      }
    },

    async updateSearch(search) {
      if (search) {
        this.search = search;
        this.page = 1;
        await this.inicializar();
      } else {
        this.page = 1;
      }
    },

    async updatePage(pagination) {
      this.page = pagination.page;
      await this.inicializar();
    },

    async listarUnidades() {
      try {
        const responseEnderecos = await axios.put("listaunidades", {}, this.config);

        this.listaDeUnidades = responseEnderecos.data.map((unidadeSelecionada) => {
          return {
            value: unidadeSelecionada.numeroEnderecoOrdemServico,
            text: unidadeSelecionada.nomeEndereco,
            numeroConfiguracaoPedido: null,
            numeroEndereco: unidadeSelecionada.numeroEnderecoOrdemServico,
            nomeEndereco: unidadeSelecionada.nomeEndereco,
          };
        });
      } catch (error) {
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
      }
    },
    //#endregion

    //#region EVENTOS REQUISIÇÃO
    async acoesModal() {
      try {
        this.loading = true;
        if (this.customModal.isEdit) {
          await this.atualizar();
        } else {
          await this.inserir();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async inserir() {
      try {
        this.alertaModal.tipo = "";
        await axios.post("configuracaopedido", this.customModal.dadosModal, this.config);

        this.alerta.texto = "Nova configuração criada com sucesso!";
        this.alerta.tipo = "sucesso";

        this.customModal.isOpen = false;
        this.mostrarSkeleton = true;
        this.inicializar();
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
      }
    },

    async atualizar() {
      try {
        this.alertaModal.tipo = "";
        await axios.put("configuracaopedido", this.customModal.dadosModal, this.config);

        this.alerta.texto = "Configuração atualizada com sucesso!";
        this.alerta.tipo = "sucesso";

        this.customModal.isOpen = false;
        this.mostrarSkeleton = true;
        this.inicializar();
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
      }
    },

    async excluir() {
      try {
        this.loading = true;
        this.alerta.tipo = "";
        await axios.delete("configuracaopedido", {
          data: this.modalDelete.dadosDelete,
          headers: this.config.headers,
        });

        this.alerta.texto = "Configuração removida com sucesso!";
        this.alerta.tipo = "sucesso";

        this.modalDelete.abrir = false;
        this.mostrarSkeleton = true;
        this.inicializar();
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        this.loading = false;
      }
    },
    //#endregion

    //#region FUNÇÕES MODAL
    async modalDeInserir() {
      this.loading = true;
      try {
        this.alertaModal.tipo = "";

        await this.listarUnidades();

        this.customModal.dadosModal.descricaoMensagem = null;
        this.customModal.dadosModal.unidadesConfiguracao = [];
        this.customModal.dadosModal.unidadesConfiguracaoExcluidos = [];
      } catch (error) {
        console.log(error);
      } finally {
        this.customModal.formTitle = "Nova Configuração";
        this.customModal.isEdit = false;
        this.customModal.isButtonsDisabled = !this.tudoValido;
        this.customModal.isButtonsVisible = true;
        this.customModal.showCloseMessage = true;
        this.customModal.isOpen = true;
        this.loading = false;
      }
    },

    async modalDeAtualizar(confSelecionada) {
      this.loading = true;
      try {
        this.alertaModal.tipo = "";

        await this.listarUnidades();

        this.customModal.dadosModal.descricaoMensagem = confSelecionada.descricaoMensagem;
        this.customModal.dadosModal.unidadesConfiguracao = confSelecionada.unidadesConfiguracao;
        this.customModal.dadosModal.unidadesConfiguracaoExcluidos = [];
      } catch (error) {
        console.log(error);
      } finally {
        this.customModal.formTitle = "Atualizar Configuração";
        this.customModal.isEdit = true;
        this.customModal.isButtonsDisabled = !this.tudoValido;
        this.customModal.isButtonsVisible = true;
        this.customModal.showCloseMessage = true;
        this.customModal.isOpen = true;
        this.loading = false;
      }
    },

    async modalDeExcluir(confSelecionada) {
      this.modalDelete.abrir = true;
      this.modalDelete.dadosDelete.unidadesConfiguracao = confSelecionada.unidadesConfiguracao;
    },
    //#endregion

    //#region HANDLERS
    adicionarTodasUnidades() {
      this.listaDeUnidades.map((unidadeSelecionada) => {
        const verificarItem = this.customModal.dadosModal.unidadesConfiguracao.filter((unidade) => unidade.numeroEndereco == unidadeSelecionada.numeroEndereco);

        if (verificarItem.length <= 0) {
          this.customModal.dadosModal.unidadesConfiguracao.unshift(unidadeSelecionada);
        }
      });
    },

    removerUnidadeConf(unidadeSelecionada) {
      this.customModal.dadosModal.unidadesConfiguracaoExcluidos.push(this.customModal.dadosModal.unidadesConfiguracao.filter((unidade) => unidade.numeroEndereco == unidadeSelecionada.numeroEndereco)[0]);
      this.customModal.dadosModal.unidadesConfiguracao = this.customModal.dadosModal.unidadesConfiguracao.filter((unidade) => unidade.numeroEndereco != unidadeSelecionada.numeroEndereco);
    },
    //#endregion
  },
};
</script>
